<ng-container *ngIf="nav.isDesktop">
  <a class="{{nav.position}} " [hidden]="nav.hidden" [routerLinkActiveOptions]="{ exact: true }"
    [routerLinkActive]="nav?.pageActive?.includes(currentPage.split('?')[0]) ? 'active' : ''" #rla="routerLinkActive" [routerLink]="nav.linkTo">
    <div class="relative w-16">
      <div class="w-1.5 {{nav.bg}} h-full active-block absolute hidden rounded-r-3xl ml003"></div>
      <div class="flex justify-center focus:outline-none relative">
        <fa-icon [ngClass]="nav?.pageActive?.includes(currentPage.split('?')[0]) ? nav.colorIconActive : nav.colorIcon" [icon]="nav.faIcon"
          class="focus:outline-none cursor-pointer {{nav.customClass}}"></fa-icon>
      </div>
    </div>
  </a>
</ng-container>